import React, { Component } from "react";

const VIDEO_OVERLAY_STYLE = {
  position: "relative",
  background: "rgb(60,64,67)",
};

const LOADING_STYLE = {
  position: "absolute",
  background: "rgba(60,64,67, .6)",
  top: '0',
  left: '0',
  zIndex: '2',
  width: "100%",
  height: "100%",
};

const CAMERA_WRAPPER_STYLE = {
  position: "absolute",
  bottom: "15px",
  right: "15px",
  zIndex: 1,
  cursor: "pointer",
};

const CAMERA_STYLE = {
  height: "calc(100%)",
  left: "-1px",
  pointerEvents: "none",
  top: "-1px",
  width: "calc(100%)",
  objectFit: "cover",
};

const ICON_BACKGROUND_STYLE = {
  backgroundColor: "white",
  border: "1px solid black",
  boxShadow: "1px 1px 10px black",
  borderRadius: "50%",
  padding: "5px",
  display: "flex",
};

const CAMERA_PICKER_STYLE = {
  width: "32px",
  height: "32px",
  fill: "#4a4747",
};

const STORAGE_VIDEO_KEY = "video-device-id";

class Webcam extends Component {
  state: State = {
    videoDevices: [],
    selectedVideoDeviceId: null,
    isLoading: true,
    hasUserMedia: false,
    logs: "",
    src: undefined,
  };

  hasMounted = false;

  hasUserMedia = false;

  videoStream = null;

  getVideoPermissions = (cb) => {
    this.setState({ logs: this.state.logs + `\nGetting permissons` });
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        this.stopVideoStream(stream)
        cb();
      })
      .catch((e) => {
        alert(e);
      });
  };

  getVideoDevices = () => {
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        this.setState({
          logs: this.state.logs + `\n${JSON.stringify(devices)}`,
        });
        const videoDevices = devices
          .filter((d) => d.kind === "videoinput")

        const savedDeviceId = localStorage.getItem(
          this.props.storedVideoDeviceId || STORAGE_VIDEO_KEY
        );
        const deviceIdNotPresent = !videoDevices.some(
          (v) => v.deviceId === savedDeviceId
        );
        if (deviceIdNotPresent) {
          localStorage.removeItem(
            this.props.storedVideoDeviceId || STORAGE_VIDEO_KEY
          );
        }

        let preferredDeviceId = null;
        for (const device of videoDevices) {
          if (device.label.toLowerCase().includes("back") || device.label.toLowerCase().includes("environment")) {
            preferredDeviceId = device.deviceId;
            break;
          }
        }
  
        // If no clear environment camera is found, fallback to the first device
        if (!preferredDeviceId && videoDevices.length > 0) {
          preferredDeviceId = videoDevices[0].deviceId;
        }

        const selectedVideoDeviceId = videoDevices.length > 0 ?
          savedDeviceId || preferredDeviceId || videoDevices[0].deviceId || null : null;

        this.setState({ videoDevices: videoDevices.map((v) => v.deviceId), selectedVideoDeviceId }, () => {
          if (this.state.selectedVideoDeviceId !== null) {
            this.handleVideoChange(this.state.selectedVideoDeviceId);
          }
        });
      })
      .catch((e) => {
        this.setState({ logs: this.state.logs + `\n${JSON.stringify(e)}` });
      });
  };

  componentDidMount() {
    if(!this.hasMounted) {
      this.getVideoPermissions(this.getVideoDevices)
      this.hasMounted = true
    }
  }

  handleVideoChange = (videoDeviceId) => {
    this.setState({
      logs:
        this.state.logs +
        `\n-Using device:${JSON.stringify({ videoDeviceId })}`,
    });

    this.setState({ isLoading: true });

    localStorage.setItem(
      this.props.storedVideoDeviceId || STORAGE_VIDEO_KEY,
      videoDeviceId
    );
    this.props.handleVideoDeviceSelect(videoDeviceId);

    if (this.props.disableSrcObject) {
      return;
    }

    const that = this;
    const video = that.props.forwardedRef.current

    navigator.mediaDevices
      .getUserMedia({
        video: {
          deviceId: videoDeviceId,
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      })
      .then(function (mediaStream) {
        if (!mediaStream) {
          that.setState({ hasUserMedia: false });
          return;
        }
        if (!that.props.disableSrcObject) {
          that.videoStream = mediaStream;
          if (video !== null) {
            try {
              video.srcObject = mediaStream;
            } catch (e) {
              that.setState({
                logs: that.state.logs + `\n${JSON.stringify(e)}`,
              });
            }
            that.setState({ hasUserMedia: true });
          }
        }
      })
      .catch((e) => {
        this.setState({ logs: this.state.logs + `\n${JSON.stringify(e)}` });
      });
  };

  handleVideoDeviceChange = () => {
    const { selectedVideoDeviceId, videoDevices } = this.state;
    if (videoDevices.length !== 0) {
      const currentIndex = videoDevices.findIndex(
        (v) => v === selectedVideoDeviceId
      );
      const newIndex =
        currentIndex + 1 > videoDevices.length - 1 ? 0 : currentIndex + 1;
      this.setState({ selectedVideoDeviceId: videoDevices[newIndex] || null });
      this.handleVideoChange(videoDevices[newIndex] || "");
    } else {
      this.getVideoDevices();
    }
  };

  stopVideoStream = (videoStream) => {
    if (videoStream !== undefined) {
      if (videoStream.getVideoTracks().length > 0) {
        videoStream.getVideoTracks().forEach((track) => {
          if (videoStream) {
            videoStream.removeTrack(track);
            track.stop();
          }
        });
      }
    }
  };

  stopAndCleanup = () => {
    const { state } = this;

    if (state.hasUserMedia) {
      this.stopVideoStream(this.videoStream);

      if (state.src) {
        window.URL.revokeObjectURL(state.src);
      }
    }
  };

  componentWillUnmount() {
    this.stopAndCleanup();
  }

  render() {
    const { style, id, forwardedRef, videoHint } = this.props;
    
    return (
      <div style={{ ...VIDEO_OVERLAY_STYLE, ...style }}>
        {this.props.loading ? <div style={LOADING_STYLE} /> : null }
        <VideoIcon
          videoHint={videoHint || "Alterar câmara"}
          onClick={this.handleVideoDeviceChange}
        />
        <video
          style={CAMERA_STYLE}
          id={id}
          className="lib-webcam"
          ref={forwardedRef}
          autoPlay
        />
      </div>
    );
  }
}

const WebcamRef = React.forwardRef(function WebcamRef(props, ref) {
  return <Webcam {...props} forwardedRef={ref} />;
});

export default WebcamRef;

function VideoIcon({
  videoHint,
  onClick,
}) {
  return (
    <div style={CAMERA_WRAPPER_STYLE} onClick={onClick}>
      <div title={videoHint} style={ICON_BACKGROUND_STYLE}>
        <svg
          style={CAMERA_PICKER_STYLE}
          xmlns="http://www.w3.org/2000/svg"
          enableBackground="new 0 0 24 24"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#000000"
        >
          <g>
            <path d="M0,0h24v24H0V0z" fill="none" />
          </g>
          <g>
            <g>
              <path d="M16,7h-1l-1-1h-4L9,7H8C6.9,7,6,7.9,6,9v6c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V9C18,7.9,17.1,7,16,7z M16,15H8V9h1.83l1-1 h2.34l1,1H16V15z" />
              <circle cx="12" cy="12" r="2" />
              <path d="M8.57,0.52L13.05,5l1.41-1.41l-1.54-1.54C17.7,2.46,21.53,6.24,22,11h2C23.36,3.3,15.79-1.67,8.57,0.52z" />
              <path d="M9.54,20.41l1.54,1.54C6.3,21.54,2.47,17.76,2,13H0c0.64,7.7,8.21,12.67,15.43,10.48L10.95,19L9.54,20.41z" />
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
}
